<template>
  <div>
    <!-- begin breadcrumb -->
    <breadcrumb activeName="商品管理" :breadcrumbItem="[{ to: '/goods/list', name: '商品列表' }]"></breadcrumb>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      商品管理
      <small>商品信息管理...</small>
    </h1>
    <!-- end page-header -->
    <panel title="商品列表" :noButton="true">
      <div slot="heading-btn">
        <button class="btn btn-theme btn-sm" type="button" @click="fn_add">
          <i class="fa fa-plus"></i> 添加商品
        </button>
      </div>
      <listFilter
        ref="listFilter"
        :categoryTree="categoryTree"
        :typeList="TypeList"
        :brandList="brandList"
        @on-search="fn_search"
      ></listFilter>
      <Table size="small" :columns="columns" :data="data">
        <template slot-scope="{ row }" slot="goods_name">
          {{row.goods_name}}
          <strong v-if="row.groupBuyCount > 0" style="color:red">[团]</strong>
        </template>

        <template slot="shop_price" slot-scope="{row}">
          <p v-for="(v,k) in row.prices" :key="k">
            {{v.attrs}} <br> 官方价: {{v.price}} <br>销售价: {{v.promotion_price}}<br> 库存数: {{v.stockquantity}}
          </p>

        </template>
        <template slot="goods_img" slot-scope="{row}" >
             <img :src="imageUrl + row.original_img" style="max-height:100px" />
        </template>

        <template slot-scope="{ row }" slot="is_on_sale">
          <span v-if="row.is_on_sale == 1">
            <Icon type="md-checkmark" />
          </span>
        </template>

        <template slot-scope="{ row }" slot="category">
          <span v-if="row.category">{{ row.category.name }}</span>
        </template>
        <template slot-scope="{ row }" slot="is_best">
          <span v-if="row.is_best == 1">
            <Icon type="md-checkmark" />
          </span>
        </template>
        <template slot-scope="{ row }" slot="is_new">
          <span v-if="row.is_new == 1">
            <Icon type="md-checkmark" />
          </span>
        </template>
        <template slot-scope="{ row }" slot="is_hot">
          <span v-if="row.is_hot == 1">
            <Icon type="md-checkmark" />
          </span>
        </template>
        <template slot="action" slot-scope="{ row, index }">
          <button class="btn btn-theme btn-sm m-l-5" type="button" @click="fn_edit(row, index)">
            <i class="fa fa-edit"></i>修改
          </button>
          <button class="btn btn-theme btn-sm m-l-5" type="button" @click="fn_activity(row, index)">
            <i class="fa fa-gift"></i>活动
          </button>

          <button
            class="btn btn-theme btn-sm m-l-5"
            type="button"
            @click="fn_edit_price(row, index)"
          >
            <Icon type="logo-yen" />价格
          </button>
          <button
            class="btn btn-theme btn-sm m-l-5"
            type="button"
            @click="fn_edit_express(row, index)"
          >
            <i class="fa fa-truck"></i>运费
          </button>
          <button class="btn btn-theme btn-sm m-l-5" type="button" @click="fn_clone(row, index)">
            <i class="fa fa-clone"></i>克隆
          </button>
          <Poptip
            class="m-l-5"
            transfer
            confirm
            title="确认要删除这商品以及相关的价格定义和价格吗?"
            @on-ok="fn_remove(row, index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button class="btn btn-danger btn-sm" type="button" ghost>
              <i class="fa fa-times"></i>删除
            </button>
          </Poptip>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="currentPage"
        :page-size="pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
    <Drawer
      :title="'商品信息  ' + goodsdata.goods_name"
      v-model="v_edit_goods"
      width="85"
      :mask-closable="true"
    >
      <listEdit
        :categoryTree="categoryTree"
        :brandList="brandList"
        :typeList="TypeList"
        :serviceList="serviceList"
        :action="action"
        :goodsdata="goodsdata"
        :quantityUnitList="quantityUnitList"
        @on_new_refresh="fn_on_new_refresh"
      ></listEdit>
    </Drawer>
    <Drawer
      :title="'商品定价  ' + goodsdata1.goods_name"
      v-model="v_edit_goods_price"
      width="80"
      :mask-closable="true"
    >
      <listPrice :typeList="TypeList" :goodsdata="goodsdata1"></listPrice>
    </Drawer>
    <Drawer
      :title="'商品运费  ' + goodsdata1.goods_name"
      v-model="v_edit_goods_delivery"
      width="50"
      :mask-closable="true"
    >
      <listDelivery :expressCorpList="expressCorpList" :goodsdata="goodsdata1"></listDelivery>
    </Drawer>
    <Drawer
      :title="'商品活动  ' + goodsdata1.goods_name"
      v-model="v_edit_goods_activity"
      width="80"
      :mask-closable="true"
    >
      <listActivity :activityList="activityList" :goodsdata="goodsdata1"></listActivity>
    </Drawer>
  </div>
</template>
<script>
import listFilter from './list_filter'
import listPrice from './list_price'
import listEdit from './list_edit'
import listDelivery from './list_delivery'
import listActivity from './listActivity'
import breadcrumb from '@/components/breadcrumb'
import {
  getGoodsList,
  getCategoryTreeSelect,
  getBrandList,
  getTypeList,
  removeGoodsData,
  getGoodsServiceList,
  getQuantityUnitList,
  cloneGoodsData,
} from '@/api/goods'
import config from '@/config'
import { getActivityList } from '@/api/activity'

import { getExpressCorpList } from '@/api/config'

export default {
  components: {
    breadcrumb,
    listFilter,
    listEdit,
    listPrice,
    listDelivery,
    listActivity,
  },
  data() {
    return {
      imageUrl: config.baseUrl.imageurl,  
      columns: [
        {
          title: '#ID',
          key: 'id',
          width: 50,
        },
        {
          title: '商品目录',
          slot: 'category',
          width: 150,
        },
        {
          title: '商品名称',
          slot: 'goods_name',
          minWidth: 100,
        },
        {
          title: '商品图片',
          slot: 'goods_img',
          minWidth: 100,
        },
        {
          title: '销售中',
          slot: 'is_on_sale',
          width: 70,
        },
        {
          title: '精品',
          slot: 'is_best',
          width: 70,
        },
        {
          title: '新品',
          slot: 'is_new',
          width: 70,
        },
        {
          title: '热销',
          slot: 'is_hot',
          width: 70,
        },
        {
          title: '排序',
          key: 'sortval',
          width: 70,
        },
        {
          title: '官方价格',
          slot: 'shop_price',
          width: 200,
        },
        {
          title: '虚拟销量',
          key: 'virtual_sales',
          width: 100,
        },
        {
          title: '销量',
          key: 'orderquantity',
          width: 100,
        },
        {
          title: '操作',
          slot: 'action',
          width: 300,
          align: 'left',
        },
      ],
      data: [],
      totalRows: 0,
      currentPage: 1,
      pageNum: 15,
      v_edit_goods: false,
      v_edit_goods_price: false,
      action: 'new',
      goodsdata: {},
      goodsdata1: {},
      categoryTree: [],
      brandList: [],
      TypeList: [],
      serviceList: [],
      quantityUnitList: [],
      v_edit_goods_delivery: false,
      expressCorpList: [],
      v_edit_goods_activity: false,
      activityList: [],
    }
  },
  mounted() {
    getTypeList({ page: 0, pageNum: 0 })
      .then((res) => {
        this.TypeList = res.data
      })
      .catch((error) => {
        this.$Message.error(error)
      })
    getBrandList({
      page: 0,
      pageNum: 0,
    }).then((res) => {
      this.brandList = res.data
    })
    getCategoryTreeSelect()
      .then((res) => {
        this.categoryTree = [
          {
            id: 0,
            label: '目录顶级节点',
            children: res.data,
          },
        ]
      })
      .catch((error) => {
        this.$Message.error(error)
      })
    getGoodsServiceList()
      .then((res) => {
        this.serviceList = res.data
      })
      .catch((error) => {
        this.$Message.error(error)
      })
    getQuantityUnitList()
      .then((res) => {
        this.quantityUnitList = res.data
      })
      .catch((error) => {
        this.$Message.error(error)
      })

    getExpressCorpList({ page: 0, pageNum: 0 })
      .then((res) => {
        this.expressCorpList = res.data
      })
      .catch((error) => {
        this.$Message.error(error)
      })

    getActivityList({ page: 0, pageNum: 0 })
      .then((res) => {
        this.activityList = res.data
      })
      .catch((error) => {
        this.$Message.error(error)
      })
    let filterCond = this.$refs.listFilter.formData
    this.fn_search(filterCond)
  },
  methods: {
    fn_search(filterCond) {
      getGoodsList(filterCond)
        .then((res) => {
          this.data = res.data.data
          this.totalRows = res.data.total
        })
        .catch((error) => {
          this.$Message.error('错误' + error)
        })
    },
    fn_add() {
      this.v_edit_goods = true
      this.action = 'new'
    },
    fn_edit(row, index) {
      this.v_edit_goods = true
      this.goodsdata = row
      this.action = 'edit'
    },
    fn_edit_price(row, index) {
      this.v_edit_goods_price = true
      this.goodsdata1 = row
    },
    fn_remove(row, index) {
      removeGoodsData(row.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.data.splice(index, 1)
          }
        })
        .catch((error) => {
          this.$Message.error(error)
        })
    },
    fn_activity(row, index) {
      this.v_edit_goods_activity = true
      this.goodsdata1 = row
    },
    fn_switchPage(page) {
      let filterCond = this.$refs.listFilter.formData
      filterCond.page = page
      this.currentPage = page
      this.fn_search(filterCond)
    },
    fn_on_new_refresh(formData) {
      this.data.unshift(formData)
    },
    fn_edit_express(row, index) {
      this.v_edit_goods_delivery = true
      this.goodsdata1 = row
    },
    fn_clone(row, index) {
      //克隆一个商品，包括对应的价格属性等
      cloneGoodsData(row.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data)
            //重新装载一下数据
            let filterCond = this.$refs.listFilter.formData
            this.fn_search(filterCond)
          } else {
            this.$Notice.error(res.data)
          }
        })
        .catch((error) => {
          this.$Message.error(error)
        })
    },
  },
}
</script>
